import classNames from "classnames";
import React, { useState } from "react";

import Close from "jsx:../../assets/svgs/close.svg";
import HeartEmptySvgIcon from "jsx:../../assets/svgs/empty-heart.svg";
import HeartFillSvgIcon from "jsx:../../assets/svgs/filled-heart.svg";
import LoadingSpinner from "../../atoms/loadingSpinner/LoadingSpinner.jsx";
import CardProductTitle from "../grid-item-card/CardProductTitle.jsx";
import NutritionPanel from "../nutritionPanel/NutritionPanel.jsx";
import Periodicity from "../periodicity/Periodicity.jsx";
import QuantityControl from "../quantity-control/QuantityControl.jsx";
import { GroupItem } from "./components/GroupItem.jsx";
import ItemImage from "./components/ItemImage.jsx";

import "./styles.styl";

import { FormattedMessage } from "react-intl";
import { del, put } from "../../util/fetch";
import ToggleSwitch from "../switch/ToggleSwitch";

export default function ItemCard(props) {
  const {
    article_name_without_qualities,
    article_quality,
    base_price_display,
    cardRef,
    cardWrapperRef,
    colorSecondary,
    container_contents,
    contents_amount_display,
    display_in_cart,
    display_inactive,
    editable,
    getItemClasses,
    getMainClassNames,
    gridStyle,
    handleAddClick,
    handleDecrementClick,
    handleDestCollapsible,
    handleIncrementClick,
    handleDropdownQuantityChange,
    handleMainContentClick,
    handleOpenModal,
    handleRemoveClick,
    isLoading,
    isEditableContainer,
    id,
    incl_deposit,
    isAtLeastOneNutrition,
    is_contained,
    isFavourite,
    isItemOpen,
    isListCard,
    inactive,
    itemRef,
    logoSmallUrl,
    listing,
    nahrwerte_string,
    num_portions_in_cart,
    openedId,
    position,
    price,
    producer_display,
    product_details,
    product_image,
    rule,
    sales_package_weight,
    sales_unit_display,
    showQuantityControl,
    soldOutText,
    stk,
    toggleFavourite,
    shouldDisplayToggle,
    subscriptionId,
    syncWithRule,
    setSyncWithRule,
    setRule,
  } = props;
  const showQuantityControlComponent =
    showQuantityControl && editable && !inactive;

  const [isLoadingSyncWithRule, setIsLoadingSyncWithRule] = useState(false);

  const updateRuleTemporaryAmount = (newAmount) => {
    const ruleId = rule.id;
    const apiUrl = "/api/rule-product/" + ruleId + "/";
    const ruleProductData = {
      temporary_amount: newAmount,
      listing: listing.id,
      subscription: subscriptionId,
    };

    return put(apiUrl, { body: ruleProductData })
      .then((response) => {
        setRule(response);
      })
      .catch((error) => {
        console.error("Failed to update temporary amount", error);
      });
  };

  const removeRule = (ruleId) => {
    const apiUrl = `/api/rule-product/${ruleId}/`;
    return del(apiUrl)
      .then((response) => {
        console.log("Rule removed successfully", response);
        return response;
      })
      .catch((error) => {
        console.error("Failed to remove rule", error);
        throw error;
      });
  };

  const handleToggleSyncWithRule = (e) => {
    e.stopPropagation();
    setIsLoadingSyncWithRule(true);
    if (!syncWithRule) {
      if (num_portions_in_cart === 0) {
        // when the num in cart is 0 and the
        // toggle is moved to checked -
        // the rule and the item are removed
        removeRule(rule.id).then(() => {
          handleRemoveClick();
          setIsLoadingSyncWithRule(false);
        });
      } else {
        updateRuleTemporaryAmount(num_portions_in_cart).then(() => {
          setSyncWithRule(true);
          setIsLoadingSyncWithRule(false);
        });
      }
    } else {
      updateRuleTemporaryAmount(rule.amount).then(() => {
        setSyncWithRule(false);
        setIsLoadingSyncWithRule(false);
      });
    }
  };
  const article_name_with_qualities = article_quality
    ? article_name_without_qualities + " - " + article_quality
    : article_name_without_qualities;
  const itemName = article_name_with_qualities;

  if (is_contained && !display_in_cart) {
    return (
      <>
        <GroupItem
          image={product_image || logoSmallUrl}
          itemName={itemName}
          itemAmount={contents_amount_display}
          editable={editable}
        />
      </>
    );
  }
  return (
    <div
      className={is_contained ? "list-item-wrapper" : "" + getItemClasses()}
      key={id.toString()}
      ref={cardRef}
      style={!isListCard ? gridStyle : {}}
    >
      <div
        className={getMainClassNames()}
        onClick={!inactive ? handleMainContentClick : undefined}
      >
        {editable &&
          display_in_cart &&
          position === "cart" &&
          num_portions_in_cart > 0 && (
            <LoadingSpinner
              isLoading={isLoading}
              clazzName="item-card__loading_icon"
            >
              <Close
                className={classNames("close-icon-cart", {
                  "close-icon-cart__contained": is_contained,
                })}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveClick(e);
                }}
              />
            </LoadingSpinner>
          )}
        {isListCard ? (
          <div className={`${position}-item__main-editable`}>
            <ItemImage
              isItemOpen={isItemOpen}
              isFavourite={isFavourite}
              showFavourite={showQuantityControlComponent}
              toggleFavourite={toggleFavourite}
              position={isListCard ? position : "catalog-grid"}
              logoSmallUrl={logoSmallUrl}
              product_image={product_image}
              itemImageAlignSelf={
                shouldDisplayToggle ? "align-self-flex-start" : ""
              }
            />
            <div
              className={classNames(`${position}-item__info`, {
                [`${position}-item__info-opened`]: isItemOpen,
              })}
            >
              <div
                className={classNames(`${position}-item__info-row`, {
                  [`${position}-item__info-row-opened`]: isItemOpen,
                })}
              >
                <CardProductTitle
                  container_contents={container_contents}
                  isItemOpen={isItemOpen}
                  isListCard={isListCard}
                  display_inactive={display_inactive}
                  hideSoldOutProps={display_inactive}
                  soldOutText={display_inactive && soldOutText}
                  article_name_with_qualities={article_name_with_qualities}
                  article_name_without_qualities={
                    article_name_without_qualities
                  }
                  article_quality={article_quality}
                  producer_display={producer_display}
                  incl_deposit={incl_deposit}
                  position={position}
                />
                {!display_inactive && !is_contained && (
                  <Periodicity
                    periodicity={
                      rule && rule.periodicity ? rule.periodicity : ""
                    }
                    editable={editable}
                    onPeriodicityClick={handleOpenModal}
                    position={position}
                  />
                )}
                {showQuantityControl && (
                  <div className={`${position}-item__info-row-price-add`}>
                    {!display_inactive && isListCard && (
                      <div className={`${position}-item__unit`}>
                        <div className="">
                          {!isEditableContainer ? price : ""}
                        </div>
                        <div className={`${position}-item__units_amounts`}>
                          <div>{stk}</div>
                          <div>{sales_unit_display}</div>
                          <div>{sales_package_weight}</div>
                        </div>
                        {!isItemOpen && (
                          <div className={`${position}-item__edit-price`}>
                            <p className="per-base-unit">
                              {base_price_display}
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                    <QuantityControl
                      num_portions_in_cart={num_portions_in_cart}
                      editable={
                        editable && showQuantityControl && !display_inactive
                      }
                      position={position}
                      colorSecondary={colorSecondary}
                      handleDecrementClick={(e) =>
                        handleDecrementClick(e, syncWithRule)
                      }
                      handleIncrementClick={(e) =>
                        handleIncrementClick(e, syncWithRule)
                      }
                      handleDropdownQuantityChange={(e, difference) =>
                        handleDropdownQuantityChange(
                          e,
                          difference,
                          syncWithRule,
                        )
                      }
                      handleAddClick={handleAddClick}
                      disableIncrement={(inactive ?? false) || !editable}
                      itemRef={itemRef}
                    />
                  </div>
                )}
              </div>
              {isItemOpen && (
                <div className={`${position}-item__info-second-row`}>
                  <div className={`${position}-item__info-second-row-main`}>
                    <div className={`${position}-item__edit-price`}>
                      <p>{base_price_display}</p>
                    </div>
                    {producer_display.length > 0 ? (
                      <div className={`${position}-item__edit-producer`}>
                        <span>{producer_display}</span>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
              {rule && shouldDisplayToggle && (
                <div
                  className={`sync-toggle ${
                    rule.is_temporary ? "sync-toggle-disabled" : ""
                  }`}
                >
                  <label>
                    <FormattedMessage id="syncWithRuleLabel" />
                  </label>

                  <ToggleSwitch
                    name="syncWithRule"
                    checked={syncWithRule}
                    handleCheckBox={handleToggleSyncWithRule}
                    isLoading={isLoadingSyncWithRule}
                    disabled={rule.is_temporary}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <div className={`${position}-grid-item__sml-image-container`}>
              <ItemImage
                isItemOpen={isItemOpen}
                position={"catalog-grid"}
                logoSmallUrl={logoSmallUrl}
                product_image={product_image}
              />
              {showQuantityControlComponent &&
                (isFavourite ? (
                  <HeartFillSvgIcon
                    onClick={toggleFavourite || undefined}
                    className={classNames("heart-icon", "heart-icon__filled")}
                  />
                ) : (
                  <HeartEmptySvgIcon
                    onClick={toggleFavourite || undefined}
                    className={classNames("heart-icon", "heart-icon__empty")}
                  />
                ))}
            </div>
            {display_inactive && position == "catalog" ? (
              <>
                {article_name_without_qualities}
                <div className={`${position}-item__sold-out`}>
                  {soldOutText}
                </div>
              </>
            ) : (
              <>
                <CardProductTitle
                  container_contents={container_contents}
                  isItemOpen={isItemOpen}
                  isListCard={isListCard}
                  hideSoldOutProps={display_inactive}
                  article_name_without_qualities={
                    article_name_without_qualities
                  }
                  article_name_with_qualities={article_name_with_qualities}
                  subTitle={price}
                  article_quality={article_quality}
                  base_price_display={base_price_display}
                  producer_display={producer_display}
                  incl_deposit={incl_deposit}
                  position={position}
                />
              </>
            )}
            <QuantityControl
              num_portions_in_cart={num_portions_in_cart}
              editable={editable && !display_inactive}
              position={position}
              handleDecrementClick={(e) =>
                handleDecrementClick(e, syncWithRule)
              }
              handleIncrementClick={(e) =>
                handleIncrementClick(e, syncWithRule)
              }
              handleDropdownQuantityChange={(e, difference) =>
                handleDropdownQuantityChange(e, difference, syncWithRule)
              }
              handleAddClick={handleAddClick}
              cardWrapperRef={cardWrapperRef}
              isGridCard
              disableIncrement={(inactive ?? false) || !editable}
            />
          </>
        )}
      </div>
      <div className={`${position}-item__edit`}>
        <NutritionPanel
          position={position}
          product_details={product_details}
          fields={product_details?.fields || []}
          id={id}
          openedId={openedId ?? `inhalt${id}`}
          handleDestCollapsible={handleDestCollapsible}
          itemRef={itemRef}
          isAtLeastOneNutrition={isAtLeastOneNutrition}
          nahrwerte_string={nahrwerte_string}
          container_contents={container_contents}
        />
      </div>
    </div>
  );
}
